import { useFilterErrorForSidePanel } from 'components/common-form/sidePanel/status/validationErrors/useFilterErrorsForSidePanel';
import type { SecondaryMarketKeys, SecondaryMarketKeysPrefix } from 'locales/secondaryMarketKeys';
import type { SecondaryMarketFormError } from 'state/secondaryMarket/shared/form/validationResults';

import type { ColorSeverityMapper } from './useTranslatedErrorMessage';
import { useTranslatedErrorMessages } from './useTranslatedErrorMessage';

export const useErrorMessagesFormatter = <F>(
  errors: readonly SecondaryMarketFormError<F>[] = [],
  colorToSeverity?: ColorSeverityMapper,
) => {
  const errorsToDisplay = useFilterErrorForSidePanel<F, SecondaryMarketKeys, SecondaryMarketKeysPrefix>(
    errors,
    true,
    [],
  );
  return useTranslatedErrorMessages<F, SecondaryMarketKeys, SecondaryMarketKeysPrefix>(
    'secondaryMarket.form.errors.',
    errorsToDisplay,
    colorToSeverity,
  );
};
